<template>
	<el-form ref="gestureForm" :model="gesture" :rules="rules" label-width="100px" v-loading="loading">

		<h1 v-if="isNew">Ajout d'un nouveau geste</h1>
		<h1 v-else>Modification du geste : {{ gesture.label }}</h1>
			
		<el-form-item label="Libellé" prop="label">
			<el-input v-model="gesture.label" placeholder="Libellé" maxlength="100"></el-input>
		</el-form-item>

		<el-form-item label="Médecin" prop="doctor">
			<el-switch v-model="gesture.doctor"></el-switch>
		</el-form-item>

		<el-form-item label="Infirmier" prop="nurse">
			<el-switch v-model="gesture.nurse"></el-switch>
		</el-form-item>

		<el-form-item label="Prescription" prop="prescription">
			<el-switch v-model="gesture.prescription"></el-switch>
		</el-form-item>

		<el-form-item label="Actif" prop="valid">
			<el-switch v-model="gesture.valid"></el-switch>
		</el-form-item>

		<div style="text-align: center;">
			<el-button icon="fas fa-times" @click="back"> Annuler</el-button>
			<el-button icon="fas fa-save" @click="submit" type="primary"> Enregistrer</el-button>
		</div>
	</el-form>
</template>

<script>
import GestureService from '@/services/gesture.service'

export default {
	name: 'gesture',
	data: function () {
		return {
			loading: true,
			gesture: {},
        	rules: {
				label: [ { required: true, message: 'Veuillez saisir le libellé du geste', trigger: 'blur' } ]
			}
		}
	},
	computed: {
		isNew: function() {
			return this.$route.params.itemId == 'new'
		}
	},
	methods: {
		submit() {
			// Valide le formulaire
			this.$refs['gestureForm'].validate((valid) => {
				if (valid) {

					// Affiche le loader
					this.loading = true

					// Enregistrement du geste
					GestureService.saveGesture(this.gesture).then(() => {

						// Retour liste
						this.$router.push('/gestures')
					})

				} else {
					return false;
				}
			});
		},
		back() {
			// Retour liste
			this.$router.push('/gestures')
		}
	},
	mounted: function() {

		// Récupère le geste si ce n'est pas un ajout
		if(!this.isNew) {
			GestureService.getGesture(this.$route.params.itemId).then((gesture) => {

				this.gesture = gesture
				this.loading = false
			})
		} else {
			this.gesture = { doctor: true, nurse: true, prescription: true, valid: true }
			this.loading = false
		}
	}
}
</script>

<style scoped>

	h1 {
		margin-bottom: 30px;
		margin-left: 30px;
	}

</style>